import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[var(--site-textarea-min-h)] w-full rounded-[var(--site-textarea-radius)] border border-[color:var(--site-border-soft)] bg-[var(--site-surface-strong)] px-[var(--site-input-px)] py-[calc(var(--site-input-py)+0.25rem)] text-[length:var(--site-input-font-size)] shadow-[var(--site-shadow-soft)] placeholder:text-[var(--site-ink-subtle)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-[length:var(--site-input-font-size)]",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
